<template>
  <div class="passenger">
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label for="sex" class="form-label">Sex</label>
          <select id="sex" ref="input" class="form-select" v-model="passenger.sex">
            <option value=""></option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="x">X</option>
          </select>
        </div>
      </div>

      <div class="col-md-3">
        <div class="mb-3">
          <label for="given_names" class="form-label">Given names</label>
          <input type="text" class="form-control" id="given_names" v-model="passenger.given_names">
        </div>
      </div>

      <div class="col-md-3">
        <div class="mb-3">
          <label for="surname" class="form-label">Surname</label>
          <input type="text" class="form-control" id="surname" v-model="passenger.surname">
        </div>
      </div>

      <div class="col-md-3">
        <div class="mb-3">
          <label for="dob" class="form-label">Date of Birth</label>
          <input type="date" class="form-control" id="dob" v-model="passenger.dob">
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-md-3">
        <SelectCountry v-model="passenger.nationality" label="Nationality" />
      </div>

      <div class="col-md-3">
        <div class="mb-3">
          <label for="passport_number" class="form-label">Passport number</label>
          <input type="text" class="form-control" id="passport_number" v-model="passenger.passport_number">
        </div>
      </div>

      <div class="col-md-3">
        <div class="mb-3">
          <label for="passport_issue" class="form-label">Passport Date of Issue</label>
          <input type="date" class="form-control" id="passport_issue" v-model="passenger.passport_issue" @change="setPassportExpireDate($event)">
        </div>
      </div>

      <div class="col-md-3">
        <div class="mb-3">
          <label for="passport_expire" class="form-label">Date of Expiration</label>
          <input type="date" class="form-control" id="passport_expire" v-model="passenger.passport_expire">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import SelectCountry from '@/Shared/SelectCountry'

export default {
  name: 'Passenger',
  components: {
    SelectCountry
  },
  props: ['passenger'],
  methods: {
    setPassportExpireDate(event) {
      let date = new Date(event.target.value)
      let newDate = new Date(date.setFullYear(date.getFullYear() + 10))

      this.passenger.passport_expire = moment(newDate).format('YYYY-MM-DD')
    },
  }
}
</script>

<style>

</style>
